import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BasicFieldCheckbox, BaasicFieldDropdown } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function DiagnosisCodeEditTemplate({ diagnosisCodeEditViewStore }) {
    const {
        contentLoading,
        form,
        itemCategoryStore,
        justificationTypesStore,
        showJustificationType
    } = diagnosisCodeEditViewStore;

    return (
        <ApplicationEditLayout store={diagnosisCodeEditViewStore}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-8 col-lrg-7">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                    <BasicInput field={form.$('code')} />
                                </div>
                                <div className="form__group col col-lrg-8 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
									<BaasicFieldDropdown field={form.$('diagnosisCodeCategories')} store={itemCategoryStore} />
								</div>
                                {showJustificationType &&
                                 <div className="form__group col col-lrg-12 u-mar--bottom--sml">
									<BaasicFieldDropdown field={form.$('diagnosisCodeJustificationTypes')} store={justificationTypesStore} />
								</div>}
                                <div className={`form__group col col-lrg-6`}>
                                    <BasicFieldCheckbox className="has-fake-label"  field={form.$('isBillable')}/><span className="fake-label">Is Billable</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

DiagnosisCodeEditTemplate.propTypes = {
    diagnosisCodeEditViewStore: PropTypes.object,
};

export default defaultTemplate(DiagnosisCodeEditTemplate);
